import { render, staticRenderFns } from "./ShippingChargeSearchForm.vue?vue&type=template&id=08cbe42e&"
import script from "./ShippingChargeSearchForm.vue?vue&type=script&lang=ts&"
export * from "./ShippingChargeSearchForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports